// extracted by mini-css-extract-plugin
module.exports = {"block":"TrendingMenu_block__pjFxZ","item":"TrendingMenu_item__gblTz","list":"TrendingMenu_list__Vgktk"};